import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sequences: [],
  loadingSequences: false,
  errorLoadingSequences: null,
};

export const sequenceSlice = createSlice({
  name: "sequence",
  initialState,
  reducers: {
    setLoadingSequences: (state) => {
      state.loadingSequences = true;
      state.errorLoadingSequences = null;
    },
    setSequences: (state, { payload }) => {
      state.loadingSequences = false;
      state.sequences = payload;
    },
    setErrorLoadingSequences: (state, { payload }) => {
      state.loadingSequences = false;
      state.errorLoadingSequences = payload;
    },
  },
});

export const { setLoadingSequences, setSequences, setErrorLoadingSequences } =
  sequenceSlice.actions;

export default sequenceSlice.reducer;
